export const MapModalTypes = {
  SearchResult: "SearchResult",
  ProjectListSelected: "ProjectListSelected",
  CurrentProject: "CurrentProject",
  Line: "Line",
  Area: "Area",
  Profile: "Profile",
  Volumn: "Volumn",
  Marker: "Marker",
};

export const MapModalAnnotateStatus = {
  Edit: "Edit",
  Success: "Success",
};

export const AnnotationTypes = {
  Line: "Line",
  Area: "Area",
  Profile: "Profile",
  Volumn: "Volumn",
  Marker: "Marker",
};

export const Dimensions = ["2D", "3D"];

export const Colors = [
  "#C23F38",
  "#712D9C",
  "#222E61",
  "#487BF2",
  "#2A8E6A",
  "#15C67D",
  "#EABA12",
  "#D57D17",
  "#DE5E56",
  "#9F51B6",
  "#385397",
  "#48A0F2",
  "#15BBC6",
  "#20DE6C",
  "#F2DF30",
  "#E4AB54",
  "#FFFFFF",
  "#E5E5E5",
  "#C4C4C4",
  "#A0A0A0",
  "#707173",
  "#000000",
  "#594139",
  "#886F65",
];

export const LabelSizes = [
  { label: 'Default', value: 1 },
  { label: 'Large', value: 2 },
  { label: 'Small', value: 3 }
];

export const LabelColors = [
  "#FFFFFF",
  "#E5E5E5",
  "#EAC3C1",
  "#F1BBDB",
  "#B3E4D0",
  "#AFE2E5",
  "#B1DAFF",
  "#FFFCE5"
];

export const PinSizes = [
  { label: 'Default', value: 1 },
  { label: 'Large', value: 2 },
  { label: 'Small', value: 3 }
];

export const Markers = [
  "360",
  "local_offer",
  "electrical_services",
  "local_shipping",
  "restaurant",
  "directions_car",
  "local_fire_department",
  "near_me",
  "directions_run",
  "handyman",
  "local_activity",
  "flight",
  "park",
  "emergency",
  "local_police",
  "directions_bus",
  "phone",
  "terrain",
  "hotel",
  "local_parking",
  "local_florist",
  "traffic",
  "train",
  "agriculture"  
]